import React from "react";
import { Colors } from "../../config";
import BizButton from "./Button";
import styled from "styled-components";

const SubmitBizTripRequestButton = ({ onSubmit }) => {
  return (
    <SubmitButtonWrapper>
      <BizButton
        onClick={onSubmit}
        width="300px"
        label="Submit Request"
        color={Colors.prussianBlue}
        isRounded
        postfixIcon={
          <img
            src={require("../../assets/images/box_submit.png")}
            style={{ width: "24px", marginLeft: "4px" }}
            alt="submit icon"
          />
        }
      />
    </SubmitButtonWrapper>
  );
};

const SubmitButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 2rem;
`;

export default SubmitBizTripRequestButton;
